import React, { useState } from "react";
import LogoLight from "../../asset/logo_light.png";
import "./LoginAndSignup.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";

const translations = {
  english: {
    forgetPassword: "Have you forgotten your password?",
    loginError: "Login failed",
    notRegistered: "Not Registered? Go to signup page",
    password: "Password",
    email: "Email Address",
    login: "Login",
  },
  german: {
    forgetPassword: "Haben Sie Ihr Passwort vergessen?",
    loginError: "Login ist fehlgeschlagen",
    notRegistered: "Nicht registriert? Zur Anmeldeseite gehen",
    password: "Passwort",
    email: "E-Mail Adresse",
    login: "Login",
  },
  italian: {
    forgetPassword: "Hai dimenticato la password?",
    loginError: "Accesso non riuscito",
    notRegistered: "Non sei registrato? Vai alla pagina di registrazione",
    password: "Password",
    email: "Indirizzo Email",
    login: "Accedi",
  },
  czech: {
    forgetPassword: "Zapomněli jste heslo?",
    loginError: "Přihlášení se nezdařilo",
    notRegistered: "Nejste registrováni? Přejděte na registrační stránku",
    password: "Heslo",
    email: "Emailová Adresa",
    login: "Přihlásit se",
  },
};
const config = require("../../config.js");
function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem("language") || "english"
  );
  const lang = translations[currentLanguage];

  const clearInput2 = () => setEmail("");
  const clearInput3 = () => setPassword("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await axios.post(
        config.env.API_BASE_URL + "/api/auth/login",
        {
          email,
          password,
        }
      );

      localStorage.setItem("token", response.data.token);
      localStorage.setItem("email", email);
      localStorage.setItem("user", JSON.stringify(response.data.user));
      navigate("/landing");
    } catch (error) {
      console.log(error);
      setError(error.response ? error.response.data.message : lang.loginError);
    }
  };

  const GotoSignupPage = () => {
    navigate("/signup");
  };

  return (
    <div className="loginandsignup-main">
      <div
        style={{
          cursor: "pointer",
          left: "30px",
          position: "absolute",
          top: "50px",
        }}
        onClick={() => {
          window.location.href = "/";
        }}
      >
        <FontAwesomeIcon icon={faArrowLeftLong} />
        <span style={{ marginLeft: "10px" }}>Back</span>
      </div>
      <div className="d-flex justify-content-center align-items-center flex-column gap-4">
        <img src={LogoLight} alt="logo" width={300} />
        <section className="loginandsignup">
          <form onSubmit={handleSubmit}>
            {error && <p className="error-message">{error}</p>}
            <div className={`input-wrap ${email ? "has-value" : ""}`}>
              <input
                type="email"
                className="login-input2"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label>{lang.email}</label>
              {email && (
                <button
                  type="button"
                  className="clear-button"
                  onClick={clearInput2}
                >
                  <FontAwesomeIcon
                    className="input-close-icon"
                    icon={faCircleXmark}
                  />
                </button>
              )}
            </div>
            <div className={`input-wrap ${password ? "has-value" : ""}`}>
              <input
                type="password"
                className="login-input3"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <label>{lang.password}</label>
              <div
                onClick={() => {
                  navigate("/recovery-password");
                }}
                style={{
                  textAlign: "right",
                  marginTop: "8px",
                  color: "gray",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                {lang.forgetPassword}
              </div>
              {password && (
                <button
                  type="button"
                  className="clear-button"
                  onClick={clearInput3}
                >
                  <FontAwesomeIcon
                    className="input-close-icon"
                    icon={faCircleXmark}
                  />
                </button>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button type="submit" className="btn-signup">
                {lang.login}
              </button>
            </div>
            <p
              className="fw-light"
              style={{ cursor: "pointer" }}
              onClick={GotoSignupPage}
            >
              {lang.notRegistered}
            </p>
          </form>
        </section>
      </div>
    </div>
  );
}

export default LoginPage;
